{
  "version": 1,
  "asset_id": "4eff5f4a-3295-4123-84ee-25afc571b29d",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/4eff5f4a-3295-4123-84ee-25afc571b29d/arwen-deck-cinema.png",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/4eff5f4a-3295-4123-84ee-25afc571b29d/arwen-deck-cinema.png",
  "original_filename": "arwen-deck-cinema.png",
  "size": 1601471,
  "content_type": "image/png",
  "created_at": "2026-07-05T03:24:52Z"
}
